<script>
//import Vertical from "./vertical";
import PublicWrapper from "./publicwrapper";
import { EventBus } from "../public-app"


export default {
  components: { PublicWrapper},
  data() {
    return {
      currencykey: process.env.MIX_CURRENCY_CONVERTER,
      recaptcha_token: '',
      selected_currency: '',
      selected_currency_symbol: '',
      exchange_rates: '',
      currencies: [],
    };
  },
  props: {
    user: {
      type: Object
    }
  },
  computed: {
    layoutType() {
        return this.$root.layout?.type;
    },
    getAdminCookies() {
      // Get all cookies and split them into an array
      var cookiesArray = document.cookie.split(';');

      // Loop through the array and get cookies with name 'admin'
      var adminCookies = [];
      for (var i = 0; i < cookiesArray.length; i++) {
        // Split the cookie into its name and value parts
        var cookie = cookiesArray[i].trim();
        var equalsIndex = cookie.indexOf('=');
        var name = cookie.substring(0, equalsIndex);
        var value = cookie.substring(equalsIndex + 1);

        // If the cookie name matches 'admin', add it to the array
        if (name === 'admin_logged') {
          adminCookies.push({ name: name, value: atob(value) });
        }
      }

      // Return the array of admin cookies
      return adminCookies;
    }

  },
  created(){
    this.getCurrencies();
    var storedcurrency = window.localStorage.getItem("currency");
    if(storedcurrency){
      var parsecurrency = JSON.parse(storedcurrency);
      console.log(parsecurrency["currency_code"]);
      this.convertCurrency(parsecurrency["currency_code"], null, parsecurrency["currency_symbol"]);
    }else if(this.selected_currency == ''){
      this.convertCurrency('GBP', null, '£');
    }
  },
  methods: {
    async recaptcha() {
           // (optional) Wait until recaptcha has been loaded.
          await this.$recaptchaLoaded()

          // Execute reCAPTCHA with action "login".
          const token = await this.$recaptcha('login');
          this.recaptcha_token = token;
          // Do stuff with the received token.
        
        },
      getCurrencies(){
        axios.get('/customer-api/currencies').then(response => {
          this.currencies = response.data;
        }).catch(error => {

        });
      },
      convertCurrency(from, to, symbol){
        axios.get('https://api.freecurrencyapi.com/v1/latest?apikey='+this.currencykey+'&currencies=EUR,USD,GBP&base_currency='+from+'').then(response => {
          this.conversion_rates = response.data;
          EventBus.$emit('currency-updated', symbol, from, response.data);
        }).catch(error => {

        });
    },
  },
  mounted() {
    this.recaptcha();
    /*var currencyItems = document.getElementsByClassName('currency');
      for(var i = 0; i < currencyItems.length; i++){
          document.getElementsByClassName('currency')[i].innerHTML = this.selected_currency_symbol;
      }*/
    var storedcurrency = window.localStorage.getItem("currency");
    if(storedcurrency){
      var parsecurrency = JSON.parse(storedcurrency);
      console.log(parsecurrency["currency_code"]);
      this.convertCurrency(parsecurrency["currency_code"], null, parsecurrency["currency_symbol"]);
    }else if(this.selected_currency == ''){
      this.convertCurrency('GBP', null, '£');
    }else{
       this.convertCurrency(this.selected_currency, null, this.selected_currency_symbol);
    }
    let self = this;
    EventBus.$on('currency-updated', function (symbol, currency, rates) {
      self.selected_currency = currency;
      self.exchange_rates = rates.data;
      self.selected_currency_symbol = symbol; 
      var currencyItems = document.getElementsByClassName('currency');
      /*for(var i = 0; i < currencyItems.length; i++){
          document.getElementsByClassName('currency')[i].innerHTML = symbol;
      }*/
      window.localStorage.setItem("currency", JSON.stringify({currency_code: currency, currency_symbol: symbol}))
    });
  },
  watch: {
    $route(){
      this.$nextTick(() => {
        this.recaptcha();
       /* var currencyItems = document.getElementsByClassName('currency');
        for(var i = 0; i < currencyItems.length; i++){
            document.getElementsByClassName('currency')[i].innerHTML = this.selected_currency_symbol;
        }*/
      });
    }
  }
};
</script>

<template>
  <div>

    <PublicWrapper :user="user" :recaptcha_token="recaptcha_token" :regError="$attrs.regerror" :seller_sessions="getAdminCookies"  :selected_currency="selected_currency" :selected_currency_symbol="selected_currency_symbol" :exchange_rates="exchange_rates" :currencies="currencies">
      <router-view :user="user" :recaptcha_token="recaptcha_token" :seller_sessions="getAdminCookies" :selected_currency="selected_currency" :selected_currency_symbol="selected_currency_symbol" :exchange_rates="exchange_rates" :currencies="currencies"></router-view>
    </PublicWrapper>
        
  </div>
</template>
